import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Wine, UtensilsCrossed, Wind } from 'lucide-react';
export function Daytime() {
  const features = [{
    icon: Wine,
    title: 'Premium Cocktails',
    description: 'Handcrafted signature drinks made with top-shelf spirits and fresh ingredients.'
  }, {
    icon: UtensilsCrossed,
    title: 'Gourmet Dining',
    description: 'A culinary journey featuring artisanal dishes prepared by our world-class chefs.'
  }, {
    icon: Wind,
    title: 'Premium Hookah',
    description: 'An extensive selection of premium flavors served in a luxurious setting.'
  }];
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-958">
      <Header data-id="element-959" />

      {/* Hero Section */}
      <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-960">
        {/* Background */}
        <div className="absolute inset-0 z-0" data-id="element-961">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0B1014] via-[#0B1014]/50 to-[#0B1014] z-10" data-id="element-962" />
          <img src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=2070&auto=format&fit=crop" alt="Daytime Dining" className="w-full h-full object-cover opacity-60" data-id="element-963" />
        </div>

        {/* Content */}
        <div className="relative z-20 text-center px-4 max-w-5xl mx-auto" data-id="element-964">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-965">
            <div className="inline-block mb-6" data-id="element-966">
              <span className="text-[#DDA247] text-sm font-bold uppercase tracking-[0.3em] border border-[#DDA247] px-6 py-2" data-id="element-967">
                11AM - 5PM
              </span>
            </div>
            <h1 className="text-6xl md:text-8xl lg:text-9xl font-bold mb-12 tracking-tight" data-id="element-968">
              DAYTIME
            </h1>

            <Link to="/book-now" data-id="element-969">
              <Button size="lg" className="min-w-[200px]" data-id="element-970">
                RESERVE TABLE
              </Button>
            </Link>
          </motion.div>
        </div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20" data-id="element-971">
          <div className="w-[1px] h-24 bg-gradient-to-b from-transparent via-[#DDA247] to-transparent animate-pulse" data-id="element-972" />
        </motion.div>
      </section>

      {/* Content Section */}
      <section className="py-24 px-4 md:px-8 bg-[#0B1014]" data-id="element-973">
        <div className="max-w-7xl mx-auto" data-id="element-974">
          <div className="text-center mb-20" data-id="element-975">
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-976">
              Gourmet dining, sports viewing, and premium hookah in a
              sophisticated atmosphere.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-977">
            {features.map((feature, index) => <motion.div key={feature.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15,
            duration: 0.6
          }} className="bg-[#11161A] border border-white/10 p-10 text-center group hover:border-[#DDA247] transition-colors duration-300" data-id="element-978">
                <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-[#DDA247]/10 rounded-full group-hover:bg-[#DDA247]/20 transition-colors duration-300" data-id="element-979">
                  <feature.icon className="w-10 h-10 text-[#DDA247]" data-id="element-980" />
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 tracking-wide" data-id="element-981">
                  {feature.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-982">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-983" />
    </div>;
}